import { Navigate } from "react-router-dom";
import { useUser } from "../hooks/useUser";
import { gestionaMultiplesArtistas } from "../utils/tiposArtista";

// Las rutas se declaran por ROL (main_routes.js), y todos estos perfiles son
// rol "artista". Lo que habilita el roster es el TIPO de ecosistema, que vive
// en el perfil, así que la condición se resuelve acá con el usuario ya
// cargado. El backend valida lo mismo por su cuenta (isMultiartista): esto
// solo evita mostrar una pantalla que igual respondería 403.
export default function SoloMultiartista({ children }) {
  const { user } = useUser();

  // Mientras el usuario no cargó no se decide nada: devolver el redirect
  // antes de tiempo sacaría al sello de su propia pantalla al recargar.
  if (!user || user.profile === undefined) return null;

  if (!gestionaMultiplesArtistas(user?.profile?.tipo))
    return <Navigate to="/artista/biblioteca" replace />;

  return children;
}
